module.exports = __webpack_public_path__ + "static/media/e2c6256b.jpg";